<template>
  <div id="divPanelCamera" :style="getCustomStyle(startGameConfig)">
    <input type="button" show="true" id="btAnimate" value="pokaż panel" />
    <div id="divC">
      <div class="set" :style="panelStyle">
        <nav class="d-pad">
          <a class="up" href="#" name="moveUp"></a>
          <a class="right" href="#" name="moveRight"></a>
          <a class="down" href="#" name="moveDown"></a>
          <a class="left" href="#" name="moveLeft"></a>
        </nav>
        <nav class="singleBtn" @click="resetCamera">
          <a class="reset" href="#">
            <svg xmlns="http://www.w3.org/2000/svg" width="41.8" height="42.18" viewBox="0 0 41.8 42.18">
              <g>
                <path
                  class="svg"
                  d="M35.48.59l-3,3A21,21,0,0,0,0,19a2,2,0,0,0,2,2.18H6.07A2,2,0,0,0,8,19.41,13,13,0,0,1,26.58,9.49l-2.27,2.27a2,2,0,0,0,1.42,3.42H36.9a2,2,0,0,0,2-2V2A2,2,0,0,0,35.48.59Z"
                />
                <path
                  class="svg"
                  d="M39.79,21H35.73a2,2,0,0,0-1.95,1.76A13,13,0,0,1,20.9,34a12.81,12.81,0,0,1-5.68-1.32l2.26-2.27A2,2,0,0,0,16.07,27H4.9a2,2,0,0,0-2,2V40.17a2,2,0,0,0,3.41,1.42l3.05-3.05A20.78,20.78,0,0,0,20.9,42,21,21,0,0,0,41.79,23.18,2,2,0,0,0,39.79,21Z"
                />
              </g>
            </svg>
          </a>
        </nav>
        <nav class="o-pad">
          <a class="up" href="#" name="moveForward">
            <svg
              class="zoom"
              xmlns="http://www.w3.org/2000/svg"
              width="475.084px"
              height="475.084px"
              viewBox="0 0 475.084 475.084"
              name="moveForward"
            >
              <g>
                <g>
                  <path
                    class="svg"
                    name="moveForward"
                    d="M464.524,412.846l-97.929-97.925c23.6-34.068,35.406-72.04,35.406-113.917c0-27.218-5.284-53.249-15.852-78.087
			c-10.561-24.842-24.838-46.254-42.825-64.241c-17.987-17.987-39.396-32.264-64.233-42.826
			C254.246,5.285,228.217,0.003,200.999,0.003c-27.216,0-53.247,5.282-78.085,15.847C98.072,26.412,76.66,40.689,58.673,58.676
			c-17.989,17.987-32.264,39.403-42.827,64.241C5.282,147.758,0,173.786,0,201.004c0,27.216,5.282,53.238,15.846,78.083
			c10.562,24.838,24.838,46.247,42.827,64.241c17.987,17.986,39.403,32.257,64.241,42.825
			c24.841,10.563,50.869,15.844,78.085,15.844c41.879,0,79.852-11.807,113.922-35.405l97.929,97.641
			c6.852,7.231,15.406,10.849,25.693,10.849c10.089,0,18.699-3.566,25.838-10.705c7.139-7.138,10.704-15.748,10.704-25.837
			S471.567,419.889,464.524,412.846z M291.363,291.358c-25.029,25.033-55.148,37.549-90.364,37.549
			c-35.21,0-65.329-12.519-90.36-37.549c-25.031-25.029-37.546-55.144-37.546-90.36c0-35.21,12.518-65.334,37.546-90.36
			c25.026-25.032,55.15-37.546,90.36-37.546c35.212,0,65.331,12.519,90.364,37.546c25.033,25.026,37.548,55.15,37.548,90.36
			C328.911,236.214,316.392,266.329,291.363,291.358z"
                  />
                  <path
                    class="svg"
                    name="moveForward"
                    d="M283.232,182.728h-63.954v-63.953c0-2.475-0.905-4.615-2.712-6.424c-1.809-1.809-3.951-2.712-6.423-2.712H191.87
			c-2.474,0-4.615,0.903-6.423,2.712c-1.807,1.809-2.712,3.949-2.712,6.424v63.953h-63.954c-2.474,0-4.615,0.905-6.423,2.712
			c-1.809,1.809-2.712,3.949-2.712,6.424v18.271c0,2.475,0.903,4.617,2.712,6.424c1.809,1.809,3.946,2.713,6.423,2.713h63.954
			v63.954c0,2.478,0.905,4.616,2.712,6.427c1.809,1.804,3.949,2.707,6.423,2.707h18.272c2.473,0,4.615-0.903,6.423-2.707
			c1.807-1.811,2.712-3.949,2.712-6.427v-63.954h63.954c2.478,0,4.612-0.905,6.427-2.713c1.804-1.807,2.703-3.949,2.703-6.424
			v-18.271c0-2.475-0.899-4.615-2.703-6.424C287.851,183.633,285.709,182.728,283.232,182.728z"
                  />
                </g>
              </g>
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
            </svg>
          </a>
          <a class="right" @click="stopRotate" href="#">
            <svg class="zoom" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 20 20">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-170.000000, -1040.000000)">
                  <g transform="translate(100.000000, 852.000000)">
                    <g transform="translate(68.000000, 186.000000)">
                      <g>
                        <polygon fill-rule="nonzero" points="0 0 24 0 24 24 0 24" />
                        <path
                          class="svg"
                          d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M11,16 L9,16 L9,8 L11,8 L11,16 Z M15,16 L13,16 L13,8 L15,8 L15,16 Z"
                          fill="#1D1D1D"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </a>
          <a class="down" href="#" name="moveBack">
            <svg
              class="zoom"
              xmlns="http://www.w3.org/2000/svg"
              width="475.084px"
              height="475.084px"
              viewBox="0 0 475.084 475.084"
              name="moveBack"
            >
              <g>
                <g>
                  <path
                    class="svg"
                    name="moveBack"
                    d="M464.524,412.846l-97.929-97.925c23.6-34.068,35.406-72.04,35.406-113.917c0-27.218-5.284-53.249-15.852-78.087
			c-10.561-24.842-24.838-46.254-42.825-64.241c-17.987-17.987-39.396-32.264-64.233-42.826
			C254.246,5.285,228.217,0.003,200.999,0.003c-27.216,0-53.247,5.282-78.085,15.847C98.072,26.412,76.66,40.689,58.673,58.676
			c-17.989,17.987-32.264,39.403-42.827,64.241C5.282,147.758,0,173.786,0,201.004c0,27.216,5.282,53.238,15.846,78.083
			c10.562,24.838,24.838,46.247,42.827,64.241c17.987,17.986,39.403,32.257,64.241,42.825
			c24.841,10.563,50.869,15.844,78.085,15.844c41.879,0,79.852-11.807,113.922-35.405l97.929,97.641
			c6.852,7.231,15.406,10.849,25.693,10.849c10.089,0,18.699-3.566,25.838-10.705c7.139-7.138,10.704-15.748,10.704-25.837
			S471.567,419.889,464.524,412.846z M291.363,291.358c-25.029,25.033-55.148,37.549-90.364,37.549
			c-35.21,0-65.329-12.519-90.36-37.549c-25.031-25.029-37.546-55.144-37.546-90.36c0-35.21,12.518-65.334,37.546-90.36
			c25.026-25.032,55.15-37.546,90.36-37.546c35.212,0,65.331,12.519,90.364,37.546c25.033,25.026,37.548,55.15,37.548,90.36
			C328.911,236.214,316.392,266.329,291.363,291.358z"
                  />
                  <path
                    class="svg"
                    name="moveBack"
                    d="M283.228,182.728h-164.45c-2.474,0-4.615,0.905-6.423,2.712c-1.809,1.809-2.712,3.949-2.712,6.424v18.271
			c0,2.475,0.903,4.617,2.712,6.424c1.809,1.809,3.946,2.713,6.423,2.713h164.454c2.478,0,4.612-0.905,6.427-2.713
			c1.804-1.807,2.703-3.949,2.703-6.424v-18.271c0-2.475-0.903-4.615-2.707-6.424C287.851,183.633,285.706,182.728,283.228,182.728z
			"
                  />
                </g>
              </g>
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
            </svg>
          </a>
          <a class="left" @click="startRotate" href="#">
            <svg class="zoom" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 20 20">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-204.000000, -952.000000)">
                  <g transform="translate(100.000000, 852.000000)">
                    <g transform="translate(102.000000, 98.000000)">
                      <g>
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path
                          class="svg"
                          d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M10,16.5 L10,7.5 L16,12 L10,16.5 Z"
                          fill="#1D1D1D"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </a>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as THREE from 'three';
import $ from 'jquery';

export default {
  name: 'mp-camera',
  components: {},
  props: {
    tjsStage: {
      type: Object,
      default: function () {
        return {};
      },
    },
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      moveLeft: false,
      moveRight: false,
      moveUp: false,
      moveDown: false,
      moveForward: false,
      moveBack: false,
      rotSpeed: 0.02,
      RAF: false,
    };
  },
  created() {},
  mounted() {
    if (typeof this.startGameConfig.moveSpeed == 'number') {
      this.rotSpeed = this.startGameConfig.moveSpeed;
    }
    $(document).ready(function () {
      $('#divC').hide();
      $('#btAnimate').click(function () {
        if ($(this).attr('show') == 'true') {
          $('#divPanelCamera').animate({ width: '650px', height: '320px' }, 500);
          $('#divC').show();
          $(this).attr('show', 'false');
          $(this).attr('value', 'schowaj panel');
        } else {
          $('#divPanelCamera').animate({ width: '110px', height: '40px' }, 500);
          $('#divC').hide('slow');
          $(this).attr('show', 'true');
          $(this).attr('value', 'pokaż panel');
        }
      });
    });
    document.addEventListener('keydown', this.onkeydown, true);
    document.addEventListener('keyup', this.onkeyup, true);
    document.addEventListener('mousedown', this.startMove, true);
    document.addEventListener('mouseup', this.stopMove, true);

    this.render();
  },
  methods: {
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    resetCamera(e) {
      this.tjsStage.reset();
      e.preventDefault();
    },
    startRotate(e) {
      this.tjsStage.rotating = true;
    },
    stopRotate(e) {
      this.tjsStage.rotating = false;
    },
    onkeydown(e) {
      //console.log('DOWN: ' + e.keyCode);
      switch (e.keyCode) {
        case 38:
          this.moveUp = true;
          break;
        case 40:
          this.moveDown = true;
          break;
        case 37:
          this.moveLeft = true;
          break;
        case 39:
          this.moveRight = true;
          break;
        case 107:
          this.moveForward = true;
          break;
        case 109:
          this.moveBack = true;
          break;
      }
      e.preventDefault();
    },
    onkeyup(e) {
      //console.log('UP: ' + e.keyCode);
      this.moveUp = false;
      this.moveDown = false;
      this.moveLeft = false;
      this.moveRight = false;
      this.moveForward = false;
      this.moveBack = false;
      e.preventDefault();
    },
    startMove(e) {
      switch ($(e.target).attr('name')) {
        case 'moveForward':
          this.moveForward = true;
          break;
        case 'moveBack':
          this.moveBack = true;
          break;
        case 'moveUp':
          this.moveUp = true;
          break;
        case 'moveDown':
          this.moveDown = true;
          break;
        case 'moveLeft':
          this.moveLeft = true;
          break;
        case 'moveRight':
          this.moveRight = true;
          break;
      }
      e.preventDefault();
    },
    stopMove(e) {
      this.moveForward = false;
      this.moveBack = false;
      this.moveUp = false;
      this.moveDown = false;
      this.moveLeft = false;
      this.moveRight = false;
    },
    render() {
      if (this.tjsStage.world == null) return;
      this.tjsStage.rotate();

      if (this.moveForward) {
        this.forward();
      }
      if (this.moveBack) {
        this.back();
      }
      if (this.moveUp) {
        this.up();
      }
      if (this.moveDown) {
        this.down();
      }
      if (this.moveLeft) {
        this.left();
      }
      if (this.moveRight) {
        this.right();
      }
      if (
        typeof this.tjsStage.world != 'undefined' &&
        this.tjsStage.world != null &&
        this.tjsStage.world.camera != 'undefined' &&
        this.tjsStage.world.camera != null
      ) {
        this.tjsStage.world.camera.updateProjectionMatrix();
      }

      this.RAF = requestAnimationFrame(this.render);
    },
    up() {
      this.tjsStage.world.camera.rotateOnAxis(new THREE.Vector3(1, 0, 0).normalize(), -this.rotSpeed);
    },

    down() {
      this.tjsStage.world.camera.rotateOnAxis(new THREE.Vector3(1, 0, 0).normalize(), this.rotSpeed);
    },

    forward() {
      // this.world.camera.position.z -= 40;
      this.tjsStage.world.camera.fov *= 1.0 - this.rotSpeed;
    },

    back() {
      // this.world.camera.position.z += 40;
      this.tjsStage.world.camera.fov *= 1.0 + this.rotSpeed;
    },
    left() {
      // var x = this.tjsStage.cameraPosition.x,
      //   y = this.tjsStage.cameraPosition.y,
      //   z = this.tjsStage.cameraPosition.z;

      // this.tjsStage.cameraPosition.x = x * Math.cos(this.rotSpeed) + z * Math.sin(this.rotSpeed);
      // this.tjsStage.cameraPosition.z = z * Math.cos(this.rotSpeed) - x * Math.sin(this.rotSpeed);
      this.tjsStage.world.camera.rotateOnAxis(new THREE.Vector3(0, 1, 0).normalize(), -this.rotSpeed);
    },

    right() {
      // var x = this.tjsStage.world.camera.position.x,
      //   y = this.tjsStage.world.camera.position.y,
      //   z = this.tjsStage.world.camera.position.z;
      // this.tjsStage.world.camera.position.x = x * Math.cos(this.rotSpeed) - z * Math.sin(this.rotSpeed);
      // this.tjsStage.world.camera.position.z = z * Math.cos(this.rotSpeed) + x * Math.sin(this.rotSpeed);
      this.tjsStage.world.camera.rotateOnAxis(new THREE.Vector3(0, 1, 0).normalize(), this.rotSpeed);
      // this.world.camera.rotateOnAxis(new THREE.Vector3(0, 1, 0).normalize(), this._degInRad(-1));
    },
    _degInRad(deg) {
      return (deg * Math.PI) / 180;
    },
  },
  computed: {
    panelStyle() {
      return {
        '--dpad-radius': '17%',
        '--dpad-radius-in': '20%',
        '--dpad-fg': '#ddd',
        '--dpad-fg-hover': '#eee',
        '--dpad-bg': '#fff',
        '--arrow-color': '#aaa',
        '--arrow-active-color': '#333',
        '--tri-sml-a': '13px',
        '--tri-sml-b': '19px',
        '--tri-lrg-a': '13px',
        '--tri-lrg-b': '19px',
        '--dpad-arrow-shift': '5px',
        '--dpad-arrow-move': '35%',
      };
    },
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onkeydown, true);
    document.removeEventListener('keyup', this.onkeyup, true);
    document.removeEventListener('mousedown', this.startMove, true);
    document.removeEventListener('mouseup', this.stopMove, true);
    window.cancelAnimationFrame(this.RAF);
    this.tjsStage.beforeDestroy();
  },
};
</script>

<style lang="scss" scoped>
#divPanelCamera {
  font: 15px Verdana;
  background-color: #fff;
  position: absolute;
  left: 20px;
  top: 150px;
  width: 110px;
  height: 40px;
  padding: 5px;
  border: solid 1px #ccf;
  border-radius: 2px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
}
#divPanelCamera label {
  width: 100%;
  color: #009872;
  font-size: 14px;
  padding: 10px;
}
#divPanelCamera input {
  padding: 3px 2px;
  border: solid 1px #3079ed;
  border-radius: 2px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  background: #6d9bf1;
  color: #fff;
  cursor: pointer;
}
#divPanelCamera div {
  padding: 20px 10px;
}
#divPanelCamera li {
  margin: 0 2px 0 0;
  display: inline;
  font-size: 0.7em;
  font-style: normal;
  padding: 2px 0 2px 2px;
  vertical-align: middle;
}

.set {
  overflow: hidden;
  padding: 30px;
  text-align: center;
  .d-pad {
    margin-right: 40px;
  }
  .d-pad,
  .o-pad,
  .singleBtn {
    display: inline-block;
    // transform: scale(.7);
  }
}
.set.setbg {
  background: #222;
}
.set.setbg2 {
  background: #5f9837;
}

.singleBtn {
  width: 85px;
  height: 85px;
  padding: 20px;
  margin-bottom: 58px;
  margin-right: 40px;
  position: relative;
  border-radius: var(--dpad-radius) var(--dpad-radius) var(--dpad-radius) var(--dpad-radius);
  overflow: hidden;
  background: var(--dpad-fg);
  &:hover {
    background: linear-gradient(0deg, var(--dpad-fg) 0%, var(--dpad-fg-hover) 50%);
    cursor: pointer;
  }
  &:active {
    .svg {
      fill: var(--arrow-active-color);
    }
  }
}

.svg {
  fill: var(--arrow-color);
}

.zoom {
  width: 42px;
  height: 42px;
}

.d-pad {
  position: relative;
  width: 200px;
  height: 200px;
  border-radius: 48%;
  overflow: hidden;
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    border-radius: 5%;
    transform: translate(-50%, -50%);
    width: 66.6%;
    height: 66.6%;
    background: var(--dpad-fg);
  }
  &:after {
    content: '';
    position: absolute;
    display: none;
    z-index: 2;
    width: 20%;
    height: 20%;
    top: 50%;
    left: 50%;
    background: var(--dpad-fg);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.25s;
    cursor: pointer;
  }
  &:hover:after {
    width: 30%;
    height: 30%;
  }
  a {
    display: block;
    position: absolute;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    width: 33.3%;
    height: 43%;
    line-height: 40%;
    color: #fff;
    background: var(--dpad-fg);
    text-align: center;
    &:hover {
      background: var(--dpad-fg-hover);
    }
    &:before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-radius: 5px;
      border-style: solid;
      transition: all 0.25s;
    }
    &:after {
      content: '';
      position: absolute;
      width: 102%;
      height: 78%;
      background: var(--dpad-bg);
      border-radius: var(--dpad-radius-in);
    }
  }

  a.left,
  a.right {
    width: 43%;
    height: 33%;
    &:after {
      width: 78%;
      height: 102%;
    }
  }

  a.up {
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    border-radius: var(--dpad-radius) var(--dpad-radius) 50% 50%;
    &:hover {
      background: linear-gradient(0deg, var(--dpad-fg) 0%, var(--dpad-fg-hover) 50%);
    }
    &:after {
      left: 0;
      top: 0;
      transform: translate(-100%, 0);
      border-top-left-radius: 50%;
      pointer-events: none;
    }
    &:before {
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-width: 0 var(--tri-sml-a) var(--tri-sml-b) var(--tri-sml-a);
      border-color: transparent transparent var(--arrow-color) transparent;
    }
    &:active:before {
      border-bottom-color: var(--arrow-active-color);
    }
  }
  a.up:hover:before {
    top: var(--dpad-arrow-move);
  }

  a.down {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    border-radius: 50% 50% var(--dpad-radius) var(--dpad-radius);
    &:hover {
      background: linear-gradient(180deg, var(--dpad-fg) 0%, var(--dpad-fg-hover) 50%);
    }
    &:after {
      right: 0;
      bottom: 0;
      transform: translate(100%, 0);
      border-bottom-right-radius: 50%;
      pointer-events: none;
    }
    &:before {
      bottom: 40%;
      left: 50%;
      transform: translate(-50%, 50%);
      border-width: var(--tri-sml-b) var(--tri-sml-a) 0px var(--tri-sml-a);
      border-color: var(--arrow-color) transparent transparent transparent;
    }
    &:active:before {
      border-top-color: var(--arrow-active-color);
    }
  }
  a.down:hover:before {
    bottom: var(--dpad-arrow-move);
  }

  a.left {
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    border-radius: var(--dpad-radius) 50% 50% var(--dpad-radius);
    &:hover {
      background: linear-gradient(-90deg, var(--dpad-fg) 0%, var(--dpad-fg-hover) 50%);
    }
    &:after {
      left: 0;
      bottom: 0;
      transform: translate(0, 100%);
      border-bottom-left-radius: 50%;
      pointer-events: none;
    }
    &:before {
      left: 40%;
      top: 50%;
      transform: translate(-50%, -50%);
      border-width: var(--tri-sml-a) var(--tri-sml-b) var(--tri-sml-a) 0;
      border-color: transparent var(--arrow-color) transparent transparent;
    }
    &:active:before {
      border-right-color: var(--arrow-active-color);
    }
  }
  a.left:hover:before {
    left: var(--dpad-arrow-move);
  }

  a.right {
    top: 50%;
    right: 0;
    transform: translate(0, -50%);
    border-radius: 50% var(--dpad-radius) var(--dpad-radius) 50%;
    &:hover {
      background: linear-gradient(90deg, var(--dpad-fg) 0%, var(--dpad-fg-hover) 50%);
    }
    &:after {
      right: 0;
      top: 0;
      transform: translate(0, -100%);
      border-top-right-radius: 50%;
      pointer-events: none;
    }
    &:before {
      right: 40%;
      top: 50%;
      transform: translate(50%, -50%);
      border-width: var(--tri-sml-a) 0 var(--tri-sml-a) var(--tri-sml-b);
      border-color: transparent transparent transparent var(--arrow-color);
    }
    &:active:before {
      border-left-color: var(--arrow-active-color);
    }
  }
  a.right:hover:before {
    right: var(--dpad-arrow-move);
  }
}
.d-pad.up a.up:before {
  border-bottom-color: var(--arrow-active-color);
}
.d-pad.down a.down:before {
  border-top-color: var(--arrow-active-color);
}
.d-pad.left a.left:before {
  border-right-color: var(--arrow-active-color);
}
.d-pad.right a.right:before {
  border-left-color: var(--arrow-active-color);
}

.o-pad {
  position: relative;
  background: var(--dpad-fg);
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
  &:after {
    content: '';
    position: absolute;
    z-index: 2;
    width: 20%;
    height: 20%;
    top: 50%;
    left: 50%;
    background: #ddd;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    display: none;
    transition: all 0.25s;
    cursor: pointer;
  }
  &:hover:after {
    width: 30%;
    height: 30%;
  }
  a {
    display: block;
    position: absolute;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    width: 50%;
    height: 50%;
    text-align: center;
    transform: rotate(45deg);
    border: 1px solid rgba(0, 0, 0, 0.2);
    &:before {
      content: '';
      position: absolute;
      width: 60%;
      height: 60%;
      top: 50%;
      left: 50%;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 50%;
      transform: translate(-50%, -50%);
      transition: all 0.25s;
      cursor: pointer;
      display: none;
    }
    &:after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-radius: 5px;
      border-style: solid;
      transform: translate(-50%, -50%) rotate(-45deg);
      transition: all 0.25s;
    }
  }
  a.up {
    bottom: 50%;
    left: 50%;
    transform: translate(-50%, -20%) rotate(45deg);
    border-top-left-radius: 50%;
    z-index: 1;
    .zoom {
      transform: translate(30%, 100%) rotate(-45deg);
    }
    &:hover {
      background: linear-gradient(315deg, rgba(255, 255, 255, 0) 15%, rgba(255, 255, 255, 0.4) 100%);
    }
    &:after {
      border-color: transparent;
    }
    &:active {
      .svg {
        fill: var(--arrow-active-color);
      }
    }
  }

  a.down {
    top: 50%;
    left: 50%;
    transform: translate(-50%, 20%) rotate(45deg);
    border-bottom-right-radius: 50%;
    z-index: 1;
    .zoom {
      transform: translate(-20%, 40%) rotate(-45deg);
    }
    &:hover {
      background: linear-gradient(135deg, rgba(255, 255, 255, 0) 15%, rgba(255, 255, 255, 0.4) 100%);
    }
    &:after {
      border-color: transparent;
      .svg {
        fill: var(--arrow-color);
      }
    }
    &:active {
      .svg {
        fill: var(--arrow-active-color);
      }
    }
  }

  a.left {
    top: 50%;
    right: 50%;
    transform: translate(-20%, -50%) rotate(45deg);
    border-bottom-left-radius: 50%;
    border: none;
    .zoom {
      transform: translate(20%, 50%) rotate(-45deg);
    }
    &:hover {
      background: linear-gradient(225deg, rgba(255, 255, 255, 0) 15%, rgba(255, 255, 255, 0.4) 100%);
    }
    &:after {
      border-color: transparent;
      .svg {
        fill: var(--arrow-color);
      }
    }
    &:active {
      .svg {
        fill: var(--arrow-active-color);
      }
    }
  }

  a.right {
    top: 50%;
    left: 50%;
    transform: translate(20%, -50%) rotate(45deg);
    border-top-right-radius: 50%;
    border: none;
    .zoom {
      transform: translate(-20%, 90%) rotate(-45deg);
    }
    &:hover {
      background: linear-gradient(45deg, rgba(255, 255, 255, 0) 15%, rgba(255, 255, 255, 0.4) 100%);
    }
    &:after {
      border-color: transparent;
      .svg {
        fill: var(--arrow-color);
      }
    }
    &:active {
      .svg {
        fill: var(--arrow-active-color);
      }
    }
  }
  a:hover:after {
    left: 50%;
    top: 50%;
  }
}

.dark {
  --c: #111;
  --c-h: #222;
  --c-t: rgba(255, 255, 255, 0.9);
  --c-t-a: #61e22d;
  .d-pad {
    a {
      border-radius: 35%;
    }
    &:before,
    a {
      background: #111;
    }
    a.up:hover {
      background: linear-gradient(0deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.right:hover {
      background: linear-gradient(90deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.down:hover {
      background: linear-gradient(180deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.left:hover {
      background: linear-gradient(-90deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.up:before {
      border-bottom-color: var(--c-t);
    }
    a.right:before {
      border-left-color: var(--c-t);
    }
    a.down:before {
      border-top-color: var(--c-t);
    }
    a.left:before {
      border-right-color: var(--c-t);
    }
    a.up:active:before {
      border-bottom-color: var(--c-t-a);
    }
    a.right:active:before {
      border-left-color: var(--c-t-a);
    }
    a.down:active:before {
      border-top-color: var(--c-t-a);
    }
    a.left:active:before {
      border-right-color: var(--c-t-a);
    }
  }
  .o-pad {
    background: var(--c);
    a {
      border-color: rgba(255, 255, 255, 0.4);
    }
    a:before {
      display: block;
    }
    &:before,
    a {
      background: var(--c);
    }
    a.up:after {
      border-bottom-color: var(--c-t);
    }
    a.right:after {
      border-left-color: var(--c-t);
    }
    a.down:after {
      border-top-color: var(--c-t);
    }
    a.left:after {
      border-right-color: var(--c-t);
    }
    a.up:active:after {
      border-bottom-color: var(--c-t-a);
    }
    a.right:active:after {
      border-left-color: var(--c-t-a);
    }
    a.down:active:after {
      border-top-color: var(--c-t-a);
    }
    a.left:active:after {
      border-right-color: var(--c-t-a);
    }
  }
}

.pink {
  --c: #ff1285;
  --c-h: #f366aa;
  --c-t: rgba(255, 255, 255, 0.7);
  --c-t-a: rgba(255, 255, 255, 1);
  .d-pad {
    &:before,
    a {
      background: var(--c);
    }
    a:after {
      border-radius: 30%;
    }
    a.up:hover {
      background: linear-gradient(0deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.right:hover {
      background: linear-gradient(90deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.down:hover {
      background: linear-gradient(180deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.left:hover {
      background: linear-gradient(-90deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.up:before {
      border-bottom-color: var(--c-t);
    }
    a.right:before {
      border-left-color: var(--c-t);
    }
    a.down:before {
      border-top-color: var(--c-t);
    }
    a.left:before {
      border-right-color: var(--c-t);
    }
    a.up:active:before {
      border-bottom-color: var(--c-t-a);
    }
    a.right:active:before {
      border-left-color: var(--c-t-a);
    }
    a.down:active:before {
      border-top-color: var(--c-t-a);
    }
    a.left:active:before {
      border-right-color: var(--c-t-a);
    }
  }
  .o-pad {
    background: var(--c);
    a {
      border-color: rgba(255, 255, 255, 0.6);
    }
    &:before,
    a {
      background: var(--c);
    }
    a.up:after {
      border-bottom-color: var(--c-t);
    }
    a.right:after {
      border-left-color: var(--c-t);
    }
    a.down:after {
      border-top-color: var(--c-t);
    }
    a.left:after {
      border-right-color: var(--c-t);
    }
    a.up:active:after {
      border-bottom-color: var(--c-t-a);
    }
    a.right:active:after {
      border-left-color: var(--c-t-a);
    }
    a.down:active:after {
      border-top-color: var(--c-t-a);
    }
    a.left:active:after {
      border-right-color: var(--c-t-a);
    }
  }
}

.clear {
  --c: #fff;
  --c-h: #6ea248;
  --c-bg: #5f9837;
  --c-t: #fff;
  --c-t-a: rgba(0, 0, 0, 0.6);
  .d-pad {
    border-radius: 0;
    a {
      border: 1px solid var(--c);
    }
    &:before,
    a {
      background: none;
    }
    a:after {
      display: none;
    }
    a.up:hover {
      background: linear-gradient(0deg, var(--c-bg) 0%, var(--c-h) 50%);
    }
    a.right:hover {
      background: linear-gradient(90deg, var(--c-bg) 0%, var(--c-h) 50%);
    }
    a.down:hover {
      background: linear-gradient(180deg, var(--c-bg) 0%, var(--c-h) 50%);
    }
    a.left:hover {
      background: linear-gradient(-90deg, var(--c-bg) 0%, var(--c-h) 50%);
    }
    a.up:before {
      border-bottom-color: var(--c-t);
    }
    a.right:before {
      border-left-color: var(--c-t);
    }
    a.down:before {
      border-top-color: var(--c-t);
    }
    a.left:before {
      border-right-color: var(--c-t);
    }
    a.up:active:before {
      border-bottom-color: var(--c-t-a);
    }
    a.right:active:before {
      border-left-color: var(--c-t-a);
    }
    a.down:active:before {
      border-top-color: var(--c-t-a);
    }
    a.left:active:before {
      border-right-color: var(--c-t-a);
    }
  }
  .o-pad {
    --c: #fff;
    background: none;
    border: 1px solid var(--c-t);
    a {
      border-color: var(--c-t);
    }
    &:before,
    a {
      background: none;
    }
    a.up:after {
      border-bottom-color: var(--c-t);
    }
    a.right:after {
      border-left-color: var(--c-t);
    }
    a.down:after {
      border-top-color: var(--c-t);
    }
    a.left:after {
      border-right-color: var(--c-t);
    }
    a.up:active:after {
      border-bottom-color: var(--c-t-a);
    }
    a.right:active:after {
      border-left-color: var(--c-t-a);
    }
    a.down:active:after {
      border-top-color: var(--c-t-a);
    }
    a.left:active:after {
      border-right-color: var(--c-t-a);
    }
  }
}

.outline {
  --c: #fff;
  --c-h: #efefef;
  --c-t: rgba(0, 0, 0, 0.1);
  .d-pad {
    border-radius: 0;
    a {
      border: 1px solid var(--c-t);
    }
    &:after,
    &:before,
    a {
      background: var(--c);
    }
    a:after {
      display: none;
    }
    a.up:hover {
      background: linear-gradient(0deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.right:hover {
      background: linear-gradient(90deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.down:hover {
      background: linear-gradient(180deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.left:hover {
      background: linear-gradient(-90deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.up:before {
      border-bottom-color: var(--c-t);
    }
    a.right:before {
      border-left-color: var(--c-t);
    }
    a.down:before {
      border-top-color: var(--c-t);
    }
    a.left:before {
      border-right-color: var(--c-t);
    }
  }
  .o-pad {
    --c: #fff;
    background: var(--c);
    border: 1px solid var(--c-t);
    a {
      border-color: var(--c-t);
    }
    &:after,
    &:before,
    a {
      background: var(--c);
    }
    a.up:after {
      border-bottom-color: var(--c-t);
    }
    a.right:after {
      border-left-color: var(--c-t);
    }
    a.down:after {
      border-top-color: var(--c-t);
    }
    a.left:after {
      border-right-color: var(--c-t);
    }
  }
}

.blue {
  --c: #1843ca;
  --c-h: #143cb9;
  --c-t: #ccc;
  --c-t-a: rgba(255, 255, 255, 1);
  .d-pad {
    &:before,
    a {
      background: var(--c);
    }
    &:after {
      display: block;
      background: var(--c-t);
    }
    a:after {
      border-radius: 10%;
    }
    a.up:hover {
      background: linear-gradient(0deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.right:hover {
      background: linear-gradient(90deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.down:hover {
      background: linear-gradient(180deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.left:hover {
      background: linear-gradient(-90deg, var(--c) 0%, var(--c-h) 50%);
    }
    a.up:before {
      border-bottom-color: var(--c-t);
    }
    a.right:before {
      border-left-color: var(--c-t);
    }
    a.down:before {
      border-top-color: var(--c-t);
    }
    a.left:before {
      border-right-color: var(--c-t);
    }
    a.up:active:before {
      border-bottom-color: var(--c-t-a);
    }
    a.right:active:before {
      border-left-color: var(--c-t-a);
    }
    a.down:active:before {
      border-top-color: var(--c-t-a);
    }
    a.left:active:before {
      border-right-color: var(--c-t-a);
    }
  }
  .o-pad {
    background: var(--c);
    a {
      border-color: rgba(255, 255, 255, 0.6);
    }
    &:before,
    a {
      background: var(--c);
    }
    &:after {
      display: block;
      background: #ccc;
    }
    a.up:after {
      border-bottom-color: var(--c-t);
    }
    a.right:after {
      border-left-color: var(--c-t);
    }
    a.down:after {
      border-top-color: var(--c-t);
    }
    a.left:after {
      border-right-color: var(--c-t);
    }
    a.up:active:after {
      border-bottom-color: var(--c-t-a);
    }
    a.right:active:after {
      border-left-color: var(--c-t-a);
    }
    a.down:active:after {
      border-top-color: var(--c-t-a);
    }
    a.left:active:after {
      border-right-color: var(--c-t-a);
    }
  }
}

.setbg.white {
  --c: #fff;
  --c-t: rgba(0, 0, 0, 0.1);
  --c-t-a: rgba(0, 0, 0, 0.6);
  --c-h: #143cb9;
  .d-pad {
    &:before,
    a {
      background: var(--c);
    }
    &:after {
      display: block;
      background: var(--c-t);
    }
    a:after {
      border-radius: 40%;
      background: #222;
    }
    a.up:hover {
      background: var(--c);
    }
    a.right:hover {
      background: var(--c);
    }
    a.down:hover {
      background: var(--c);
    }
    a.left:hover {
      background: var(--c);
    }
    a.up:before {
      border-bottom-color: #0074d9;
    }
    a.right:before {
      border-left-color: #ff851b;
    }
    a.down:before {
      border-top-color: #3d9970;
    }
    a.left:before {
      border-right-color: #ffdc00;
    }
    a.up:active:before {
      border-bottom-color: var(--c-t-a);
    }
    a.right:active:before {
      border-left-color: var(--c-t-a);
    }
    a.down:active:before {
      border-top-color: var(--c-t-a);
    }
    a.left:active:before {
      border-right-color: var(--c-t-a);
    }
  }
  .o-pad {
    background: var(--c);
    a {
      border-color: rgba(255, 255, 255, 0.6);
    }
    &:before,
    a {
      background: var(--c);
    }
    &:after {
      display: block;
      background: #ccc;
    }
    a.up:after {
      border-bottom-color: #2ecc40;
    }
    a.right:after {
      border-left-color: #85144b;
    }
    a.down:after {
      border-top-color: #7fdbff;
    }
    a.left:after {
      border-right-color: #b10dc9;
    }
    a.up:active:after {
      border-bottom-color: var(--c-t-a);
    }
    a.right:active:after {
      border-left-color: var(--c-t-a);
    }
    a.down:active:after {
      border-top-color: var(--c-t-a);
    }
    a.left:active:after {
      border-right-color: var(--c-t-a);
    }
  }
}

.wire {
  --c: #93b4ff;
  .d-pad {
    overflow: initial;
    border: 1px dashed var(--c);
    &:after {
      display: block;
    }
    &:after,
    &:before,
    a,
    a:after {
      background: none;
      border: 1px solid var(--c);
    }
    a:after {
      border: 1px dashed var(--c);
    }
    a.up:before {
      border-bottom-color: var(--c);
    }
    a.right:before {
      border-left-color: var(--c);
    }
    a.down:before {
      border-top-color: var(--c);
    }
    a.left:before {
      border-right-color: var(--c);
    }
    a:hover {
      background: none;
    }
  }
  .o-pad {
    border: 1px dashed var(--c);
    background: none;
    overflow: initial;
    &:after,
    a:before {
      display: block;
    }
    &:after,
    &:before,
    a,
    a:before {
      background: none;
      border: 1px solid var(--c);
    }
    a.up:after {
      border-bottom-color: var(--c);
    }
    a.right:after {
      border-left-color: var(--c);
    }
    a.down:after {
      border-top-color: var(--c);
    }
    a.left:after {
      border-right-color: var(--c);
    }
    a:hover {
      background: none;
    }
  }
}

// set direction active state

.d-pad.up a.up:before {
  border-bottom-color: var(--arrow-active-color);
}
.d-pad.down a.down:before {
  border-top-color: var(--arrow-active-color);
}
.d-pad.left a.left:before {
  border-right-color: var(--arrow-active-color);
}
.d-pad.right a.right:before {
  border-left-color: var(--arrow-active-color);
}

.o-pad.up a.up:after {
  border-bottom-color: var(--arrow-active-color);
}
.o-pad.down a.down:after {
  border-top-color: var(--arrow-active-color);
}
.o-pad.left a.left:after {
  border-right-color: var(--arrow-active-color);
}
.o-pad.right a.right:after {
  border-left-color: var(--arrow-active-color);
}
</style>
